import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-background-50/10"
      }`}
    >
      <nav className="mx-auto flex h-16 items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md text-lg ${
              scrolled
                ? "bg-primary-500 text-background-50"
                : "bg-background-50/15 text-background-50 ring-1 ring-background-50/30"
            }`}
          >
            <i className="ri-spy-line" />
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            网曝<span className="text-primary-500">·</span>速查
          </span>
        </a>

        <ul className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <li key={link.key}>
              <a
                href={`#${link.key}`}
                className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                  scrolled ? "text-foreground-700" : "text-background-50/90"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#archives"
            className="hidden items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap sm:inline-flex"
          >
            <i className="ri-radar-line" />
            开始追踪
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors md:hidden ${
              scrolled
                ? "bg-secondary-100 text-foreground-800"
                : "bg-background-50/15 text-background-50 ring-1 ring-background-50/30"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-lg`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <ul className="grid gap-1">
            {navLinks.map((link) => (
              <li key={link.key}>
                <a
                  href={`#${link.key}`}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-secondary-100"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}